/* so-track — our branded order-tracking page (/pages/track and the /a/track takeover).
   Spec: docs/superpowers/specs/2026-09-30-order-tracking-page-design.md; API:
   docs/superpowers/specs/2026-09-30-order-tracking-page-contract.md (smoke-organic repo).
   so-mail (links.smokeorganic.co.za) builds ALL customer-facing order text; this file only lays it out.
   Rules: server strings go in with textContent / setAttribute only (never innerHTML); server URLs pass
   safeUrl() first; no date maths; localStorage (soTrack:<order> = unlock token) is always try/catch and
   optional — the page works without it. Exported for node --test (so-track.test.cjs). */
(function (root) {
  'use strict';

  var API = 'https://links.smokeorganic.co.za';
  var WA_DEFAULT = 'https://wa.me/27650632330';
  var STORE_PREFIX = 'soTrack:';
  var TIMEOUT_MS = 12000;
  var TRACK_TIMEOUT_MS = 8000;
  var RETRY_DELAY_MS = 1500;

  // ── helpers (pure) ──────────────────────────────────────────────────────────────────────────
  // "17011", "#17011", " 17011 " → "17011"; anything else → null. Also accepts a URL-encoded "%23".
  function orderFrom(v) {
    if (v == null) return null;
    var s = String(v).trim().replace(/^%23/i, '').replace(/^#/, '').trim();
    return /^\d{1,12}$/.test(s) ? s : null;
  }
  // The order to open: the Liquid-provided one (takeover path), else ?order=, else /a/track/<n>.
  function initialOrder(dataOrder, loc) {
    var o = orderFrom(dataOrder);
    if (o) return o;
    try {
      var m = /[?&]order=([^&#]*)/.exec((loc && loc.search) || '');
      if (m) { o = orderFrom(decodeURIComponent(m[1])); if (o) return o; }
      var p = /^\/a\/track\/([^/?#]+)\/?$/.exec((loc && loc.pathname) || '');
      if (p) return orderFrom(decodeURIComponent(p[1]));
    } catch (e) { /* malformed escape → no order */ }
    return null;
  }
  // Server URLs are data too: only allow what each slot needs, never javascript:/data:.
  function safeUrl(u, kind) {
    if (typeof u !== 'string' || !u || /[\s\u0000-\u001f\\<>"']/.test(u)) return null;
    switch (kind) {
      case 'wa': return /^https:\/\/(wa\.me|api\.whatsapp\.com)\//i.test(u) ? u : null;
      case 'maps': return /^https:\/\/(www\.)?google\.[a-z.]+\/maps[/?]/i.test(u) || /^https:\/\/maps\.google\.[a-z.]+\//i.test(u) ? u : null;
      case 'img': return /^https:\/\/[^/]/i.test(u) ? u : null;
      case 'https': return /^https:\/\/[^/]/i.test(u) ? u : null;                // courier.trackingUrl only
      case 'tel': return /^tel:\+?[0-9][0-9()-]{2,19}$/i.test(u) ? u : null;       // courier.phoneHref only
      case 'site': return (/^\/(?![/\\])/.test(u) || /^https:\/\/(www\.)?smokeorganic\.co\.za\//i.test(u)) ? u : null;
      default: return null;
    }
  }
  function str(v) { return typeof v === 'string' ? v : (typeof v === 'number' ? String(v) : ''); }
  function arr(v) { return Array.isArray(v) ? v : []; }

  // Stage -> fallback chip label + tone (used only when the service has not sent statusLabel / tone yet).
  var STAGE = {
    awaiting_payment: { label: 'Waiting for payment', tone: 'attention' },
    received: { label: 'Order received', tone: 'active' },
    waiting_stock: { label: 'Waiting for stock', tone: 'active' },
    booked: { label: 'Packed', tone: 'active' },
    in_transit: { label: 'On its way', tone: 'active' },
    out_for_delivery: { label: 'Out for delivery', tone: 'active' },
    ready_to_collect: { label: 'Ready to collect', tone: 'active' },
    delivered: { label: 'Delivered', tone: 'done' },
    collected: { label: 'Collected', tone: 'done' },
    late: { label: 'Running late', tone: 'attention' },
    cancelled: { label: 'Cancelled', tone: 'attention' }
  };
  function stageOf(s) { return STAGE[s] || { label: '', tone: 'active' }; }
  function toneOf(p) {
    return p.tone === 'active' || p.tone === 'done' || p.tone === 'attention' ? p.tone : stageOf(p.stage).tone;
  }
  function chipLabel(p) { return str(p.statusLabel) || stageOf(p.stage).label; }

  // ── storage (optional) ──────────────────────────────────────────────────────────────────────
  function getToken(storage, order) {
    try { return (storage && storage.getItem(STORE_PREFIX + order)) || null; } catch (e) { return null; }
  }
  function setToken(storage, order, token) {
    try { if (storage) { storage.setItem(STORE_PREFIX + order, token); return true; } } catch (e) { /* blocked */ }
    return false;
  }
  function dropToken(storage, order) {
    try { if (storage) storage.removeItem(STORE_PREFIX + order); } catch (e) { /* blocked */ }
  }

  // ── DOM builder: text nodes and attributes only ────────────────────────────────────────────
  function mk(doc) {
    return function h(tag, attrs, kids) {
      var n = doc.createElement(tag);
      if (attrs) for (var k in attrs) {
        if (!Object.prototype.hasOwnProperty.call(attrs, k)) continue;
        var v = attrs[k];
        if (v == null || v === false) continue;
        if (k === 'text') n.textContent = String(v);
        else n.setAttribute(k, v === true ? '' : String(v));
      }
      arr(kids).forEach(function (c) {
        if (c == null || c === false || c === '') return;
        n.appendChild(typeof c === 'string' ? doc.createTextNode(c) : c);
      });
      return n;
    };
  }

  function isFailure(r) {
    if (!r || r.status >= 500) return true;
    if (r.status === 200) { var b = r.body; return !b || typeof b !== 'object' || typeof b.found !== 'boolean'; }
    return false;
  }
  // Both tries failed on an /a/track page: swap our component for Bob Go's own page (kept inert in <template id="so-trk-bobgo">).
  function bobgoFallback(rootEl, doc) {
    try {
      var tpl = doc.getElementById && doc.getElementById('so-trk-bobgo');
      if (!tpl || !tpl.content || !rootEl.parentNode) return false;
      if (root.console && root.console.warn) root.console.warn('so-track: falling back to Bob Go');
      doc.title = 'Track your order';
      var frag = tpl.content.cloneNode(true);
      var scripts = [].slice.call(frag.querySelectorAll('script'));
      var parent = rootEl.parentNode;
      parent.replaceChild(frag, rootEl);
      // Re-create scripts (inert inside a template) in document order, awaiting external loads.
      var chain = Promise.resolve();
      scripts.forEach(function (old) {
        chain = chain.then(function () {
          return new Promise(function (resolve) {
            var n = doc.createElement('script');
            for (var i = 0; i < old.attributes.length; i++) n.setAttribute(old.attributes[i].name, old.attributes[i].value);
            n.text = old.text;
            if (old.src) { n.onload = resolve; n.onerror = resolve; }
            old.parentNode.replaceChild(n, old);
            if (!old.src) resolve();
          });
        });
      });
      chain.then(function () {
        try { doc.title = 'Track your order'; doc.dispatchEvent(new root.Event('DOMContentLoaded')); root.dispatchEvent(new root.Event('load')); } catch (e) { /* ignore */ }
      });
      return true;
    } catch (e) { return false; }
  }

  // ── the app ────────────────────────────────────────────────────────────────────────────────
  var uid = 0;
  function mount(rootEl, env) {
    env = env || {};
    var doc = env.document || root.document;
    var h = mk(doc);
    var fetchFn = env.fetch || (root.fetch && root.fetch.bind(root));
    var storage = env.storage !== undefined ? env.storage : safeLocalStorage();
    var loc = env.location || root.location || {};
    var hist = env.history || root.history;
    var endpoint = String(rootEl.getAttribute('data-endpoint') || API).replace(/\/+$/, '');
    var cid = rootEl.getAttribute('data-customer-id') || '';
    var sig = rootEl.getAttribute('data-customer-sig') || '';
    var app = rootEl.querySelector('[data-so-track-app]') || rootEl;
    var titleEl = rootEl.querySelector('[data-so-track-title]');
    var leadEl = rootEl.querySelector('[data-so-track-lead]');
    var baseTitle = titleEl ? titleEl.textContent : '';
    var baseLead = leadEl ? leadEl.textContent : '';
    var id = 'so-trk-' + (++uid);
    var mem = {};           // tokens kept in memory when localStorage is blocked
    var seq = 0;            // drops stale responses

    function waUrl(d) { return safeUrl(d && d.whatsappUrl, 'wa') || WA_DEFAULT; }
    function setHero(title, lead) {
      rootEl.removeAttribute('data-view');
      if (titleEl) titleEl.textContent = title;
      if (leadEl) { leadEl.textContent = lead || ''; if (lead) leadEl.removeAttribute('hidden'); else leadEl.setAttribute('hidden', ''); }
    }
    function show(nodes, focusEl) {
      app.textContent = '';
      nodes.forEach(function (n) { if (n) app.appendChild(n); });
      if (focusEl && focusEl.focus) { try { focusEl.focus(); } catch (e) { /* ignore */ } }
    }
    function tokenFor(order) { return mem[order] || getToken(storage, order); }
    function remember(order, token) { mem[order] = token; setToken(storage, order, token); }
    function forget(order) { delete mem[order]; dropToken(storage, order); }
    function setUrl(order) {
      try {
        if (!hist || !hist.replaceState) return;
        var path = String(loc.pathname || '/');
        if (/^\/a\/track(\/|$)/.test(path)) hist.replaceState(null, '', '/a/track/' + order);
        else hist.replaceState(null, '', path + (order ? '?order=' + order : ''));
      } catch (e) { /* ignore */ }
    }

    function request(url, opts, timeoutMs) {
      if (!fetchFn) return Promise.reject(new Error('no fetch'));
      var ctl = null, timer = null;
      try { ctl = typeof AbortController !== 'undefined' ? new AbortController() : null; } catch (e) { ctl = null; }
      if (ctl) { opts.signal = ctl.signal; timer = setTimeout(function () { ctl.abort(); }, timeoutMs || TIMEOUT_MS); }
      return Promise.resolve(fetchFn(url, opts)).then(function (res) {
        if (timer) clearTimeout(timer);
        return Promise.resolve(res.json ? res.json() : null).catch(function () { return null; }).then(function (body) {
          var ra = null;
          try { ra = res.headers && res.headers.get ? res.headers.get('Retry-After') : null; } catch (e) { ra = null; }
          return { status: res.status, body: body || {}, retryAfter: ra };
        });
      }, function (err) { if (timer) clearTimeout(timer); throw err; });
    }

    // ── views ──
    function btn(text, cls, attrs) {
      var a = attrs || {}; a.type = a.type || 'button'; a['class'] = 'so-trk__btn ' + (cls || ''); a.text = text;
      return h('button', a);
    }
    // Link buttons also carry so-ipg__btn: so-info-page.css colours every `.so-ipg a:not(.so-ipg__btn)` navy at
    // (0,2,1), which beat our (0,2,0) button colours and hid the label (navy on navy). The class opts out.
    function linkBtn(text, href, cls, ext, ico) {
      return h('a', { 'class': 'so-trk__btn so-ipg__btn ' + (cls || ''), href: href, target: ext ? '_blank' : null, rel: ext ? 'noopener' : null },
        [ico ? icon(ico) : null, h('span', { text: text })]);
    }
    function waBtn(text, d, cls) { return linkBtn(text, waUrl(d), 'so-trk__btn--wa ' + (cls || ''), true, 'chat'); }
    function icon(name) { return h('span', { 'class': 'so-trk__i so-trk__i--' + name, 'aria-hidden': 'true' }); }
    // Slim help row (Charl 2026-09-30, change 8): one line + a text link-button (keeps so-ipg__btn).
    function help(d) {
      return h('p', { 'class': 'so-trk__helprow' }, [
        h('span', { text: 'Something not right?' }),
        linkBtn('WhatsApp us', waUrl(d), 'so-trk__btn--link', true, null),
        h('span', { text: '\u00b7 065 063 2330' })
      ]);
    }
    function differentOrder() {
      var b = btn('Track a different order', 'so-trk__btn--quiet');
      b.addEventListener('click', function () { setUrl(''); showLookup({}); });
      return b;
    }

    function lookupForm(opts) {
      opts = opts || {};
      var oId = id + '-order', cId = id + '-contact', eId = id + '-lerr';
      var orderIn = h('input', { id: oId, name: 'order', type: 'text', inputmode: 'numeric', autocomplete: 'off',
        'class': 'so-trk__input', placeholder: 'e.g. 17011', required: true, 'aria-describedby': eId });
      if (opts.order) orderIn.value = opts.order;
      var contactIn = h('input', { id: cId, name: 'contact', type: 'text', autocomplete: 'email', 'class': 'so-trk__input',
        placeholder: 'Email or phone number', 'aria-describedby': cId + '-hint' });
      var err = h('p', { id: eId, 'class': 'so-trk__err', role: 'alert' });
      if (opts.error) err.textContent = opts.error;
      var submit = btn('Track my order', 'so-trk__btn--navy', { type: 'submit' });
      var form = h('form', { 'class': 'so-trk__form so-trk__panel', novalidate: true, 'aria-label': 'Find your order' }, [
        h('label', { 'class': 'so-trk__lbl', 'for': oId, text: 'Order number' }), orderIn,
        h('label', { 'class': 'so-trk__lbl', 'for': cId }, ['Email or phone ', h('span', { 'class': 'so-trk__opt', text: '(optional)' })]), contactIn,
        h('p', { id: cId + '-hint', 'class': 'so-trk__hint', text: 'Add the email or phone number you ordered with to see your items and order again.' }),
        err, submit
      ]);
      form.addEventListener('submit', function (ev) {
        if (ev && ev.preventDefault) ev.preventDefault();
        var o = orderFrom(orderIn.value);
        if (!o) { err.textContent = 'Enter the order number from your confirmation email, e.g. 17011.'; orderIn.setAttribute('aria-invalid', 'true'); if (orderIn.focus) orderIn.focus(); return; }
        orderIn.removeAttribute('aria-invalid');
        var c = String(contactIn.value || '').trim();
        setUrl(o);
        load(o, { contact: c || null, focus: true });
      });
      return form;
    }

    function showLookup(opts) {
      setHero(baseTitle, baseLead);
      var form = lookupForm(opts);
      show([form]);
    }

    function showLoading(order) {
      // Same shape as the result: the status card with grey placeholders, so nothing jumps when the data lands.
      setHero('Order #' + order, '');
      rootEl.setAttribute('data-view', 'result');
      var bars = [];
      for (var i = 0; i < 5; i++) bars.push(h('span'));
      show([h('div', { 'class': 'so-trk__card so-trk__skelcard' }, [
        h('span', { 'class': 'so-trk__sr', role: 'status', 'aria-live': 'polite', text: 'Finding order #' + order + '…' }),
        h('div', { 'class': 'so-trk__skelrow', 'aria-hidden': 'true' }, [h('b', { text: 'Order #' + order }), h('span', { 'class': 'so-trk__spin' })]),
        h('span', { 'class': 'so-trk__sk so-trk__sk--chip', 'aria-hidden': 'true' }),
        h('span', { 'class': 'so-trk__sk so-trk__sk--h', 'aria-hidden': 'true' }),
        h('span', { 'class': 'so-trk__sk so-trk__sk--l', 'aria-hidden': 'true' }),
        h('div', { 'class': 'so-trk__skbar', 'aria-hidden': 'true' }, bars),
        h('span', { 'class': 'so-trk__sk so-trk__sk--c', 'aria-hidden': 'true' })
      ])]);
    }

    function showMessage(kind, order, d) {
      var again = differentOrder();
      var nodes;
      if (kind === 'notfound') {
        setHero('Order not found', '');
        nodes = [
          h('div', { 'class': 'so-trk__msg so-trk__panel is-err', role: 'alert' }, [icon('alert'),
            h('p', { text: 'We can’t find order ' + order + '. Check the number in your confirmation email.' })]),
          lookupForm({ order: order }), help(d)
        ];
      } else if (kind === 'bad') {
        setHero(baseTitle, baseLead);
        nodes = [lookupForm({ error: 'Enter the order number from your confirmation email, e.g. 17011.' }), help(d)];
      } else {
        setHero('Order #' + order, '');
        var retry = btn('Try again', 'so-trk__btn--navy');
        retry.addEventListener('click', function () { load(order, {}); });
        nodes = [
          h('div', { 'class': 'so-trk__msg so-trk__panel is-err', role: 'alert' }, [icon('alert'), h('div', null, [
            h('p', { 'class': 'so-trk__msg-t', text: 'We can’t load your order right now.' }),
            h('p', { text: 'Please try again in a minute, or message us on WhatsApp.' })])]),
          h('div', { 'class': 'so-trk__row' }, [retry, waBtn('WhatsApp us', d)])
        ];
      }
      if (kind !== 'bad') nodes.push(again);
      show(nodes);
    }

    // 5-segment progress bar: done = navy, current (the step the parcel is AT) = half orange, todo = grey.
    // Times stay in the DOM for screen readers; the visible times live in the Updates list.
    function steps(list) {
      var ol = h('ol', { 'class': 'so-trk__steps' });
      arr(list).forEach(function (s) {
        var state = s && (s.state === 'done' || s.state === 'current') ? s.state : 'todo';
        var srText = state === 'done' ? 'Done: ' : state === 'current' ? 'Now: ' : 'Next: ';
        var time = str(s && s.timeLabel);
        ol.appendChild(h('li', { 'class': 'so-trk__step is-' + state, 'aria-current': state === 'current' ? 'step' : null }, [
          h('span', { 'class': 'so-trk__seg', 'aria-hidden': 'true' }),
          h('span', { 'class': 'so-trk__step-t' }, [
            h('span', { 'class': 'so-trk__sr', text: srText }),
            h('span', { 'class': 'so-trk__step-l', text: str(s && s.label) }),
            time ? h('span', { 'class': 'so-trk__sr so-trk__step-time', text: ', ' + time }) : null
          ])
        ]));
      });
      return ol;
    }

    // Pickup card: 88px thumbnail, type, name, address; landmark + hours; Directions; "How to collect" open only when ready.
    function pickupBlock(pk, ready) {
      var maps = safeUrl(pk.mapsUrl, 'maps'), photo = safeUrl(pk.photoUrl, 'img');
      var how = arr(pk.howTo).filter(function (x) { return str(x); });
      var dir = maps ? linkBtn('Directions', maps, ready ? 'so-trk__btn--navy so-trk__btn--sm' : 'so-trk__btn--ghost so-trk__btn--sm', true, 'map') : null;
      var facts = [
        str(pk.landmark) ? h('p', { 'class': 'so-trk__pk-line' }, [icon('flag'), h('span', { text: str(pk.landmark) })]) : null,
        str(pk.hours) ? h('p', { 'class': 'so-trk__pk-line' }, [icon('clock'), h('span', { text: str(pk.hours) })]) : null
      ].filter(Boolean);
      var gtk = arr(pk.goodToKnow).filter(function (g) { return g && typeof g === 'object' && str(g.label); });
      var by = gtk.filter(function (g) { return /^Collect by/.test(str(g.label)); })[0];
      var sup = pk.support && typeof pk.support === 'object' ? pk.support : null;
      var supHref = sup ? safeUrl(sup.phoneHref, 'tel') : null;
      var supBtn = sup && supHref && str(sup.name) ? h('a', { 'class': 'so-trk__btn so-ipg__btn so-trk__btn--ghost so-trk__btn--sm', href: supHref,
        'aria-label': 'Call ' + str(sup.name) + (str(sup.phone) ? ' on ' + str(sup.phone) : '') }, [icon('phone'), h('span', { text: 'Call ' + str(sup.name) })]) : null;
      var gtkBlock = gtk.length || supBtn ? h('div', { 'class': 'so-trk__gtk' }, [
        h('p', { 'class': 'so-trk__gtk-h', text: 'Good to know' }),
        gtk.length ? h('ul', { 'class': 'so-trk__gtk-list' }, gtk.map(function (g) {
          return h('li', {}, [h('strong', { 'class': 'so-trk__gtk-l', text: str(g.label) }), str(g.text) ? h('span', { 'class': 'so-trk__gtk-t', text: str(g.text) }) : null]);
        })) : null,
        supBtn ? h('div', { 'class': 'so-trk__gtk-act' }, [supBtn]) : null]) : null;
      var howList = how.length ? h('details', { 'class': 'so-trk__how-wrap', open: ready }, [
        h('summary', { 'class': 'so-trk__how-sum', text: 'How to collect' }),
        h('ol', { 'class': 'so-trk__how' }, how.map(function (x) { return h('li', { text: str(x) }); })),
        gtkBlock]) : null;
      return h('section', { 'class': 'so-trk__pickup so-trk__panel' + (ready ? ' is-hero' : ''), 'aria-label': 'Pickup point' }, [
        h('div', { 'class': 'so-trk__pk-top' }, [
          h('span', { 'class': 'so-trk__pk-img' }, [photo ? h('img', { src: photo, alt: str(pk.name) ? 'Photo of ' + str(pk.name) : '', loading: 'lazy', width: '88', height: '88' }) : null]),
          h('div', { 'class': 'so-trk__pk-b' }, [
            str(pk.typeLabel) ? h('p', { 'class': 'so-trk__eyebrow', text: str(pk.typeLabel) }) : null,
            h('h3', { 'class': 'so-trk__pk-name', text: str(pk.name) }),
            by ? h('p', { 'class': 'so-trk__collect-by', text: str(by.label) }) : null,
            str(pk.address) ? h('p', { 'class': 'so-trk__pk-addr', text: str(pk.address) }) : null
          ])
        ]),
        facts.length ? h('div', { 'class': 'so-trk__facts' }, facts) : null,
        dir ? h('div', { 'class': 'so-trk__pk-act' }, [dir]) : null,
        howList
      ]);
    }

    function itemRow(it) {
      var href = safeUrl(it.productUrl, 'site'), img = safeUrl(it.imageUrl, 'img');
      var title = str(it.title);
      var qty = typeof it.qty === 'number' && it.qty > 0 ? Math.floor(it.qty) : null;
      return h('li', { 'class': 'so-trk__item' }, [
        h('span', { 'class': 'so-trk__item-img' }, [img ? h('img', { src: img, alt: '', loading: 'lazy', width: '56', height: '56' }) : null]),
        h('span', { 'class': 'so-trk__item-b' }, [
          href ? h('a', { 'class': 'so-trk__item-t', href: href, text: title }) : h('span', { 'class': 'so-trk__item-t', text: title }),
          str(it.variantTitle) ? h('span', { 'class': 'so-trk__item-v', text: str(it.variantTitle) }) : null,
          (it.preorder === true || it.available === false) ? h('span', { 'class': 'so-trk__item-tags' }, [
            it.preorder === true ? h('span', { 'class': 'so-trk__tag so-trk__tag--po', text: 'Pre-order' }) : null,
            it.available === false ? h('span', { 'class': 'so-trk__tag', text: 'Not available right now' }) : null
          ]) : null
        ]),
        qty ? h('span', { 'class': 'so-trk__item-q', text: '×' + qty, 'aria-label': 'Quantity ' + qty }) : null
      ]);
    }
    function itemList(items) {
      return h('ul', { 'class': 'so-trk__item-list', role: 'list' }, items.map(itemRow));
    }

    // Courier row: logo box, name + copyable tracking ref, then Call (tel:) and "Courier site" (https only).
    function courierBlock(courier) {
      var name = str(courier.name), ref = str(courier.trackingRef);
      var tel = safeUrl(courier.phoneHref, 'tel'), trackUrl = safeUrl(courier.trackingUrl, 'https');
      if (!name && !ref && !tel && !trackUrl) return null;
      var copy = null;
      if (ref) {
        var label = h('span', { 'class': 'so-trk__copied', 'aria-hidden': 'true' });
        copy = h('button', { type: 'button', 'class': 'so-trk__iconbtn', 'aria-label': 'Copy tracking number' }, [icon('copy'), label]);
        var timer = null;
        copy.addEventListener('click', function () {
          var done = function () {
            copy.setAttribute('aria-label', 'Copied'); copy.setAttribute('class', 'so-trk__iconbtn is-copied'); label.textContent = 'Copied';
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              copy.setAttribute('aria-label', 'Copy tracking number'); copy.setAttribute('class', 'so-trk__iconbtn'); label.textContent = '';
            }, 2000);
          };
          try {
            var nav = env.navigator || root.navigator;
            if (nav && nav.clipboard && nav.clipboard.writeText) nav.clipboard.writeText(ref).then(done, function () { /* ignore */ });
          } catch (e) { /* ignore */ }
        });
      }
      var who = name || 'the courier';
      var phone = str(courier.phone);
      var acts = [
        tel ? h('a', { 'class': 'so-trk__btn so-ipg__btn so-trk__btn--ghost so-trk__btn--sm', href: tel,
          'aria-label': phone ? 'Call ' + who + ' on ' + phone : 'Call ' + who }, [icon('phone'), h('span', { text: 'Call' })]) : null,
        trackUrl ? h('a', { 'class': 'so-trk__btn so-ipg__btn so-trk__btn--ghost so-trk__btn--sm', href: trackUrl, target: '_blank', rel: 'noopener',
          'aria-label': 'Track on the ' + who + ' site' }, [icon('ext'), h('span', { text: 'Courier site' })]) : null
      ].filter(Boolean);
      return h('div', { 'class': 'so-trk__courier' }, [
        h('span', { 'class': 'so-trk__logo', 'aria-hidden': 'true' }, [icon('truck')]),
        (name || ref) ? h('div', { 'class': 'so-trk__cinfo' }, [
          name ? h('b', { 'class': 'so-trk__courier-n', text: name }) : null,
          ref ? h('span', { 'class': 'so-trk__ref' }, ['Tracking ', h('span', { 'class': 'so-trk__mono', text: ref }), copy]) : null
        ]) : null,
        acts.length ? h('div', { 'class': 'so-trk__courier-acts' }, acts) : null
      ]);
    }

    function isDone(p) {
      if (p.stage === 'delivered' || p.stage === 'collected') return true;
      var st = arr(p.steps); var last = st[st.length - 1];
      return !!(last && last.state === 'done');
    }

    // Status card: order line, chip, headline, detail, note, progress bar, courier row. All words are the service's.
    function parcelCard(p, i, n, d, placed, order) {
      var headId = id + '-p' + i;
      var courier = !d.courierUnavailable && p.courier && typeof p.courier === 'object' ? courierBlock(p.courier) : null;
      var est = p.estimate && typeof p.estimate === 'object' ? p.estimate : null;
      var urgent = p.stage === 'late' || p.stage === 'cancelled';
      var tone = toneOf(p), chip = chipLabel(p);
      var card = h('article', { 'class': 'so-trk__card is-' + tone + (p.kind === 'pickup' ? ' is-pickup' : ''), 'aria-labelledby': headId }, [
        h('h2', { id: headId, 'class': n > 1 ? 'so-trk__parcel' : 'so-trk__sr', text: n > 1 ? 'Parcel ' + (i + 1) + ' of ' + n : 'Your order status' }),
        h('div', { 'class': 'so-trk__orderline' }, [h('b', { text: 'Order #' + order }), placed ? h('span', { text: placed }) : null]),
        chip ? h('span', { 'class': 'so-trk__chip' }, [h('i', { 'aria-hidden': 'true' }), chip]) : null,
        h('div', { 'class': 'so-trk__hl-row' }, [
          h('p', { 'class': 'so-trk__headline', role: 'status', text: str(p.headline) }),
          est && est.guaranteed === true ? h('span', { 'class': 'so-trk__badge', text: 'Guaranteed' }) : null
        ]),
        str(p.detail) ? h('p', { 'class': 'so-trk__detail', text: str(p.detail) }) : null,
        str(p.note) ? h('p', { 'class': 'so-trk__note', text: str(p.note) }) : null,
        arr(p.steps).length ? h('div', { 'class': 'so-trk__progress' }, [
          h('h3', { 'class': 'so-trk__sr', text: 'Progress' }), steps(p.steps)]) : null,
        courier,
        urgent ? waBtn('Message us on WhatsApp', d, 'so-trk__btn--block') : null
      ]);
      var out = [card];
      if (p.kind === 'pickup' && p.pickup && typeof p.pickup === 'object') out.push(pickupBlock(p.pickup, p.stage === 'ready_to_collect'));
      var upd = updatesCard(p.updates, i);
      if (upd) out.push(upd);
      return out;
    }

    // Updates: newest first, the first 3 shown, then "See all N updates". Hidden entirely if the service sent none.
    function updatesCard(list, i) {
      var ups = Array.isArray(list) ? list.filter(function (u) { return u && typeof u === 'object' && str(u.title); }) : [];
      if (!ups.length) return null;
      var SHOW = 3;
      var ul = h('ul', { 'class': 'so-trk__feed', role: 'list' }, ups.map(function (u, k) {
        return h('li', { 'class': 'so-trk__ev', hidden: k >= SHOW }, [
          h('span', { 'class': 'so-trk__dotp', 'aria-hidden': 'true' }),
          h('span', { 'class': 'so-trk__ev-b' }, [
            h('b', { text: str(u.title) }),
            str(u.place) ? h('span', { text: str(u.place) }) : null]),
          str(u.timeLabel) ? h('span', { 'class': 'so-trk__ev-t', text: str(u.timeLabel) }) : null
        ]);
      }));
      var more = null;
      if (ups.length > SHOW) {
        more = btn('See all ' + ups.length + ' updates', 'so-trk__more', { 'aria-expanded': 'false' });
        more.addEventListener('click', function () {
          Array.prototype.forEach.call(ul.children, function (li) { li.removeAttribute('hidden'); });
          more.setAttribute('hidden', '');
        });
      }
      return h('section', { 'class': 'so-trk__updates so-trk__panel', 'aria-labelledby': id + '-u' + i }, [
        h('h2', { id: id + '-u' + i, 'class': 'so-trk__block-h', text: 'Updates' }), ul, more]);
    }

    function unlockForm(order, prefill, error) {
      var inId = id + '-unlock', eId = id + '-uerr';
      var input = h('input', { id: inId, name: 'contact', type: 'text', autocomplete: 'email', 'class': 'so-trk__input',
        placeholder: 'Email or phone number', required: true, 'aria-describedby': eId });
      if (prefill) input.value = prefill;
      var err = h('p', { id: eId, 'class': 'so-trk__err', role: 'alert' });
      if (error) err.textContent = error;
      var submit = btn('Show my items', 'so-trk__btn--navy', { type: 'submit' });
      var form = h('form', { 'class': 'so-trk__unlock', novalidate: true, 'aria-label': 'See your items', hidden: !error }, [
        h('label', { 'class': 'so-trk__lbl', 'for': inId, text: 'Enter the email or phone you ordered with' }),
        input, err, submit,
        h('p', { 'class': 'so-trk__hint', text: 'We only use it to check this order.' })
      ]);
      var open = btn('Show my items', 'so-trk__btn--ghost so-trk__btn--sm', { 'aria-expanded': error ? 'true' : 'false' });
      open.addEventListener('click', function () {
        form.removeAttribute('hidden'); open.setAttribute('aria-expanded', 'true'); open.setAttribute('hidden', '');
        if (input.focus) input.focus();
      });
      if (error) open.setAttribute('hidden', '');
      var wrap = h('section', { 'class': 'so-trk__unlockrow so-trk__panel', 'aria-label': 'See what is in this order' }, [
        h('div', { 'class': 'so-trk__quiet' }, [
          h('p', null, [h('b', { text: 'See what\u2019s in this order.' }), ' Enter the email or phone you ordered with to order again or leave a review.']),
          open]),
        form
      ]);
      form.addEventListener('submit', function (ev) {
        if (ev && ev.preventDefault) ev.preventDefault();
        var c = String(input.value || '').trim();
        if (!c) { err.textContent = 'Enter the email or phone number you ordered with.'; input.setAttribute('aria-invalid', 'true'); return; }
        input.removeAttribute('aria-invalid');
        submit.setAttribute('disabled', ''); form.setAttribute('aria-busy', 'true'); err.textContent = '';
        unlock(order, c).then(function (r) {
          submit.removeAttribute('disabled'); form.removeAttribute('aria-busy');
          if (r.ok) return load(order, { focus: true });
          err.textContent = r.error;
        });
      });
      return wrap;
    }

    function unlockError(r) {
      if (r.status === 403) return 'That doesn’t match this order. Check the email or phone number you used at checkout.';
      if (r.status === 429) {
        var s = parseInt(r.retryAfter, 10);
        if (s > 0) { var m = Math.max(1, Math.ceil(s / 60)); return 'Too many tries. Please try again in ' + m + (m === 1 ? ' minute.' : ' minutes.'); }
        return 'Too many tries. Please try again in a few minutes.';
      }
      return 'We couldn’t check that right now. Please try again.';
    }
    function unlock(order, contact) {
      return request(endpoint + '/track/unlock', {
        method: 'POST', credentials: 'omit',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ order: order, contact: contact })
      }).then(function (r) {
        if (r.status === 200 && r.body && typeof r.body.token === 'string' && r.body.token) {
          remember(order, r.body.token);
          return { ok: true };
        }
        return { ok: false, status: r.status, error: unlockError(r) };
      }, function () { return { ok: false, status: 0, error: unlockError({ status: 0 }) }; });
    }

    // Change 6/7: one "Your order" card below the status: items, review links, Order again (outlined while
    // anything is still on its way; primary orange next to the reviews once every parcel is delivered/collected).
    function orderCard(d, parcels) {
      var items = arr(d.items).filter(function (x) { return x && typeof x === 'object'; });
      var ro = d.reorder && typeof d.reorder === 'object' ? d.reorder : null;
      var roUrl = ro && safeUrl(ro.url, 'site');
      var reviews = arr(d.reviews).filter(function (r) { return r && safeUrl(r.url, 'site') && str(r.title); });
      if (!items.length && !roUrl && !reviews.length) return null;
      var allDone = parcels.length > 0 && parcels.every(isDone);
      var skipped = ro ? arr(ro.skipped).map(str).filter(Boolean) : [];
      var againBtn = roUrl ? linkBtn('Order again', roUrl, allDone ? 'so-trk__btn--buy so-trk__btn--block' : 'so-trk__btn--ghost so-trk__btn--block') : null;
      return h('section', { 'class': 'so-trk__order so-trk__panel' + (allDone ? ' is-done' : ''), 'aria-labelledby': id + '-order-h' }, [
        h('h2', { id: id + '-order-h', 'class': 'so-trk__block-h', text: 'Your order' }),
        items.length ? itemList(items) : null,
        reviews.length ? h('div', { 'class': 'so-trk__reviews' }, [
          h('h3', { 'class': 'so-trk__sub-h', text: 'How was your order?' }),
          h('ul', { 'class': 'so-trk__rev-list', role: 'list' }, reviews.map(function (r) {
            return h('li', null, [h('span', { 'class': 'so-trk__rev-t', text: str(r.title) }),
              h('a', { 'class': 'so-trk__btn so-ipg__btn so-trk__btn--ghost so-trk__btn--sm', href: safeUrl(r.url, 'site'), text: 'Write a review',
                'aria-label': 'Write a review of ' + str(r.title) })]);
          }))
        ]) : null,
        againBtn ? h('div', { 'class': 'so-trk__again' }, [againBtn,
          skipped.length ? h('p', { 'class': 'so-trk__skipped', text: 'Not available right now: ' + skipped.join(', ') }) : null]) : null
      ]);
    }

    function showResult(d, opts) {
      opts = opts || {};
      var order = orderFrom(d.order) || opts.order;
      setHero('Order #' + order, str(d.placedLabel));
      rootEl.setAttribute('data-view', 'result');
      var parcels = arr(d.parcels).filter(function (p) { return p && typeof p === 'object'; });
      var personal = d.personal === true;
      var nodes = [];
      if (personal && str(d.greeting)) nodes.push(h('p', { 'class': 'so-trk__greeting', text: str(d.greeting) }));   // change 9
      if (d.courierUnavailable === true) {
        nodes.push(h('div', { 'class': 'so-trk__msg so-trk__panel', role: 'note' }, [icon('info'),
          h('p', { text: 'Courier updates are temporarily unavailable. Here\u2019s what we know from our side.' })]));
      }
      parcels.forEach(function (p, i) { parcelCard(p, i, parcels.length, d, str(d.placedLabel), order).forEach(function (n) { nodes.push(n); }); });
      if (personal) nodes.push(orderCard(d, parcels));
      else nodes.push(unlockForm(order, opts.contact, opts.unlockError));
      nodes.push(help(d));
      nodes.push(differentOrder());
      show(nodes, opts.focus ? titleEl : null);
    }

    function load(order, opts) {
      opts = opts || {};
      var my = ++seq;
      showLoading(order);
      var qs = 'order=' + encodeURIComponent(order);
      var tok = tokenFor(order);
      if (tok) qs += '&token=' + encodeURIComponent(tok);
      if (cid && sig) qs += '&cid=' + encodeURIComponent(cid) + '&sig=' + encodeURIComponent(sig);
      var url = endpoint + '/track?' + qs;
      var ropts = function () { return { method: 'GET', credentials: 'omit', headers: { Accept: 'application/json' } }; };
      // A failure = network error, timeout, 5xx, or a body that is not the contract shape. 200 not-found, 400, 403, 429 are answers.
      function tryOnce() {
        return request(url, ropts(), TRACK_TIMEOUT_MS).then(function (r) {
          return isFailure(r) ? { fail: true } : r;
        }, function () { return { fail: true }; });
      }
      var retryDelay = env.retryDelayMs != null ? env.retryDelayMs : RETRY_DELAY_MS;
      var wait = env.wait || function (ms) { return new Promise(function (res) { setTimeout(res, ms); }); };
      return tryOnce().then(function (r) {
        if (!r.fail) return r;
        return wait(retryDelay).then(tryOnce);
      }).then(function (r) {
        if (r.fail) {
          if (my === seq && (env.bobgoFallback || bobgoFallback)(rootEl, doc)) return null;
          return { status: 503, body: {} };
        }
        return r;
      })
        .then(function (r) {
          if (!r || my !== seq) return;
          var b = r.body || {};
          if (r.status === 200 && b.found === true) {
            if (tok && b.personal !== true) forget(order);          // expired / revoked token
            if (b.personal !== true && opts.contact) {
              return unlock(order, opts.contact).then(function (u) {
                if (my !== seq) return;
                if (u.ok) return load(order, { focus: opts.focus });
                showResult(b, { order: order, contact: opts.contact, unlockError: u.error, focus: opts.focus });
              });
            }
            return showResult(b, { order: order, focus: opts.focus });
          }
          if (r.status === 200 && b.found === false) return showMessage('notfound', orderFrom(b.order) || order, b);
          if (r.status === 400) return showMessage('bad', order, b);
          return showMessage('unavailable', order, b);
        }, function () { if (my === seq) showMessage('unavailable', order, null); });
    }

    var first = initialOrder(rootEl.getAttribute('data-order'), loc);
    if (first) load(first, {}); else showLookup({});
    return { load: load, showLookup: showLookup };
  }

  function safeLocalStorage() {
    try { return root.localStorage || null; } catch (e) { return null; }
  }

  var api = { isFailure: isFailure, orderFrom: orderFrom, initialOrder: initialOrder, safeUrl: safeUrl, mount: mount, STAGE: STAGE };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  root.SO = root.SO || {};
  root.SO.track = api;
  function boot() {
    var els = root.document.querySelectorAll('[data-so-track]');
    for (var i = 0; i < els.length; i++) {
      if (els[i].getAttribute('data-so-track-ready')) continue;
      els[i].setAttribute('data-so-track-ready', '1');
      mount(els[i], {});
    }
  }
  if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', boot); else boot();
})(typeof window !== 'undefined' ? window : this);
